const dialogStore = {
  namespaced: 'DIALOG',
  state: {
    dialog_stack: [],

    search_executives: false, // 결재선_임직원검색
    search_vacation_executives: false, // 근태/휴가신청 대리업무자 검색
    change_approval_line: false, // 결재선_결재선변경
    add_referrer: false, // 결재선_참조자추가
    select_work_term: false, // 근무현황_근무기간선택
    calendar_detail: false, // 일정_일정상세
    application_viewer: false, // 신청서 뷰어
    member_profile: false, // 직원찾기_직원프로필
    board_detail: false, // 공지사항_공지사항상세
    pay_detail: false, // 급여명세서_상세
    pay_calc_detail: false, // 급여명세서_계산방법_상세
    application_confirm: false, // 신청완료뷰어
    reject_reason: false, // 반려사유
    select_annual_plan_date: false, // 연차계획작성 날짜선택
    find_password: false, // 로그인_비밀번호찾기
    reset_password_single: false, // 로그인_비밀번호재설정_단건
    reset_password_multi: false, // 로그인_비밀번호재설정_다건
    attendance_sta : false, //부서원 근태 캘린더 상세보기

    dialog_param: {}, // 모달에 전달하는 파라미터
    dialog_callback: false, // 모달종료후 콜백여부
    add_mgrrer: false, // 결재선_담당자추가
    date_hol_replace_app: false, // 휴일근무사전대체신청 캘린더
    hol_replace_cancel_view: false, // 휴일근무사전대체 취소신청
    work_schedule_time: false, // 시차출퇴근 상세보기 캘린더
    date_vacation_app: false, // 휴가신청 캘린더
    date_vacation_app2: false, // 휴가신청 캘린더
    date_vacation_app3: false, // 휴가신청 캘린더
  },
  getters: {
    GET_DIALOG_STACK(state) {
      return state.dialog_stack;
    },
    GET_DIALOG_STACK_SIZE(state) {
      return state.dialog_stack.length;
    },
    GET_DIALOG_PARAM(state) {
      return state.dialog_param;
    },
    GET_DIALOG_CALLBACK(state) {
      return state.dialog_callback;
    },
  },
  mutations: {
    INIT_MODAL(state, modalName){
      // console.log(modalName + ' modal init.');
      const stackIndex = state.dialog_stack.indexOf(modalName);
      if (stackIndex !== -1) state.dialog_stack.splice(stackIndex, 1);

      const used = state[modalName];
      if(used === undefined) return;

      state[modalName] = false;
    },
    TOGGLE_MODAL(state, modalName) {
      // console.log('state :::: ' + JSON.stringify(state));
      // 다이얼로그 스택 쌓기
      const stackIndex = state.dialog_stack.indexOf(modalName);
      if (stackIndex !== -1) {
        state.dialog_stack.splice(stackIndex, 1);
      } else {
        state.dialog_stack.push(modalName);
      }

      // 다이얼로그 토글
      const used = state[modalName];
      if(used === undefined) return;
      //fixme : 2024-06-17 PCJ. 모달 추가될때마다 아래 스위치문 추가 안해도됨
      state[modalName] = !state[modalName];

      // if(state[modalName] === false) state.dialog_param = {};

      // switch (modalName) {
      //   case 'search_executives':
      //     state.search_executives = !state.search_executives;
      //     break;
      //   case 'search_vacation_executives':
      //     state.search_vacation_executives = !state.search_vacation_executives;
      //     break;
      //   case 'change_approval_line':
      //     state.change_approval_line = !state.change_approval_line;
      //     break;
      //   case 'add_referrer':
      //     state.add_referrer = !state.add_referrer;
      //     break;
      //   case 'select_work_term':
      //     state.select_work_term = !state.select_work_term;
      //     break;
      //   case 'calendar_detail':
      //     state.calendar_detail = !state.calendar_detail;
      //     break;
      //   case 'application_viewer':
      //     state.application_viewer = !state.application_viewer;
      //     break;
      //   case 'member_profile':
      //     state.member_profile = !state.member_profile;
      //     break;
      //   case 'board_detail':
      //     state.board_detail = !state.board_detail;
      //     break;
      //   case 'pay_detail':
      //     state.pay_detail = !state.pay_detail;
      //     break;
      //   case 'pay_calc_detail':
      //     state.pay_calc_detail = !state.pay_calc_detail;
      //     break;
      //   case 'application_confirm':
      //     state.application_confirm = !state.application_confirm;
      //     break;
      //   case 'reject_reason':
      //     state.reject_reason = !state.reject_reason;
      //     break;
      //   case 'select_annual_plan_date':
      //     state.select_annual_plan_date = !state.select_annual_plan_date;
      //     break;
      //   case 'find_password':
      //     state.find_password = !state.find_password;
      //     break;
      //   case 'reset_password_single':
      //     state.reset_password_single = !state.reset_password_single;
      //     break;
      //   case 'reset_password_multi':
      //     state.reset_password_multi = !state.reset_password_multi;
      //     break;
      //   case 'add_mgrrer': //담당자팝업추가
      //     state.add_mgrrer = !state.add_mgrrer;
      //     break;
      //   case 'date_hol_replace_app': // 휴일근무사전대체신청 캘린더
      //     state.date_hol_replace_app = !state.date_hol_replace_app;
      //     break;
      //   case 'hol_replace_cancel_view': // 휴일근무사전대체신청 캘린더
      //     state.hol_replace_cancel_view = !state.hol_replace_cancel_view;
      //     break;
      //   case 'work_schedule_time': // 시차출퇴근 상세보기 캘린더
      //     state.work_schedule_time = !state.work_schedule_time;
      //     break;
      //   case 'date_vacation_app':
      //     state.date_vacation_app = !state.date_vacation_app;
      //     break;
      //   case 'date_vacation_app2':
      //     state.date_vacation_app2 = !state.date_vacation_app2;
      //     break;
      //    case 'date_vacation_app3':
      //     state.date_vacation_app3 = !state.date_vacation_app3;
      //     break;
      //   case 'attendance_sta'://부서원 근태현황 상세보기
      //     state.attendance_sta = !state.attendance_sta;
      //     break;
      // }
    },
    SET_DIALOG_PARAM(state, data) {
      state.dialog_param = data;
    },
    SET_DIALOG_CALLBACK(state, data) {
      state.dialog_callback = data;
    },
  },
};

export default dialogStore;
